var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.788,
    height: 9.486,
    viewBox: "0 0 15.788 9.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.545 -21.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.545 21.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.882,30.761a.513.513,0,0,0,.848,0l2.245-3.242a.507.507,0,0,0-.416-.8H6.212V21.916A.412.412,0,0,0,5.8,21.5H4.832a.412.412,0,0,0-.416.416v4.805H3.053a.507.507,0,0,0-.416.8Z",
    transform: "translate(-2.545 -21.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,1.8H.416A.412.412,0,0,1,0,1.38V.416A.412.412,0,0,1,.416,0H8.5a.412.412,0,0,1,.416.416V1.38A.412.412,0,0,1,8.5,1.8Z",
    transform: "translate(6.876 0.016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.416,0H6.684A.412.412,0,0,1,7.1.416V1.38a.412.412,0,0,1-.416.416H.416A.412.412,0,0,1,0,1.38V.416A.422.422,0,0,1,.416,0Z",
    transform: "translate(6.876 3.841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.416,0H4.872a.412.412,0,0,1,.416.416V1.38a.412.412,0,0,1-.416.416H.416A.412.412,0,0,1,0,1.38V.416A.412.412,0,0,1,.416,0Z",
    transform: "translate(6.876 7.682)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescending);
export default __webpack_public_path__ + "static/media/descending.a058202cc2609356d55d6f7b9d3276f0.svg";
export { ForwardRef as ReactComponent };